import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ZmianyBlozuPage = lazy(() => import("@/features/reports/zmiany-blozu-page"));

// `.catch(undefined)` na kazdym polu — zly param ze starego bookmarka ma zostac
// zignorowany, a nie wywalic trase ZodErrorem.
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	dateFrom: isoDate,
	dateTo: isoDate,
	typ: z.enum(["utrata", "ponowne_uzycie", "przekodowanie", "nadanie"]).optional().catch(undefined),
	widok: z.enum(["lista", "ranking"]).optional().catch(undefined),
});

export type ZmianyBlozuSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/zmiany-blozu")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.zmiany-blozu",
			location.pathname,
		);
	},
	component: ZmianyBlozuPage,
	validateSearch: (search: Record<string, unknown>): ZmianyBlozuSearch =>
		searchSchema.parse(search),
});
